import type { RequiredGeneric } from '@pba/react-utils';
import { startOfDay } from 'date-fns';
import { Col, DatePicker, type DatePickerDateType, Form, FormSection, Icon, Row, Switch, Text } from 'ui';
import { useStartDateRules } from '../hooks';
import { type ExtendedStartDateFormValues, StartDateFormContent } from '../start-date-form-content';

export type ExtendedReminderDurationFormValues = {
  isAllDay: boolean;
  startDate: DatePickerDateType;
} & ExtendedStartDateFormValues;

const ReminderDurationFormContent = <T extends ExtendedReminderDurationFormValues = never>(_: RequiredGeneric<T>) => {
  const startDateRules = useStartDateRules();
  const isAllDay = Form.useWatch<ExtendedReminderDurationFormValues['isAllDay']>('isAllDay');

  return (
    <FormSection title={{ children: 'Date and time', icon: <Icon icon="time-line" /> }}>
      <Form.Item<ExtendedReminderDurationFormValues>>
        <Row gutter="xs">
          <Col>
            <Form.Item<ExtendedReminderDurationFormValues> name="isAllDay" noStyle valuePropName="checked">
              <Switch size="small" />
            </Form.Item>
          </Col>
          <Col>
            <Text size="small">All day</Text>
          </Col>
        </Row>
      </Form.Item>
      <Row gutter="xs">
        <Col span={12}>
          <Form.Item<ExtendedReminderDurationFormValues> label="Date" name="startDate" rules={startDateRules}>
            <DatePicker fullWidth minimum={startOfDay(new Date())} />
          </Form.Item>
        </Col>
        {isAllDay ? null : (
          <Col span={12}>
            <StartDateFormContent<ExtendedReminderDurationFormValues> />
          </Col>
        )}
      </Row>
    </FormSection>
  );
};

export default ReminderDurationFormContent;
